import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import LoginScreen from './login-screen'
// import { setCurrentGameType, fetchAllLevelsProperties } from '../../ducks/duck-game';
import {fsLoginUserSocial} from "../../ducks/duck-user";

function LoginScreenContainer(props) {
	return (
		<LoginScreen {...props}/>
	);
}

LoginScreenContainer.propTypes = {
	booleans: PropTypes.object.isRequired,

	fsLoginUserSocial: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
	return {
		booleans: state.configReducer.appConfig.booleans,
	};
}

export default connect(mapStateToProps, {
	fsLoginUserSocial
})(LoginScreenContainer);
